import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Image } from "@react-pdf/renderer";
import { logos } from "../../../hook/Arreglos";

// Estilos del PDF
const styles = StyleSheet.create({
    // Página y encabezado
    page: { padding: 20, fontFamily: "Helvetica" },
    header: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 10,
    },
    logo: { width: 80, height: "auto" },
    contractNumber: { fontSize: 10, fontWeight: "bold", marginTop: 5 },

    // Tarjetas de información
    cardContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 10, // Espaciado entre tarjetas
    },
    card: {
        width: "32%", // Ancho ajustado para que los cuadros sean más anchos
        borderWidth: 1,
        borderColor: "#ccc",
        borderRadius: 5,
        padding: 8,
        backgroundColor: "#f9f9f9",
    },
    cardTitle: { fontSize: 10, fontWeight: "bold", color: "#000", marginBottom: 6 }, // Títulos en negro
    cardText: { fontSize: 7, color: "#333", marginBottom: 3 }, // Valores en gris oscuro
    divider: { borderBottomWidth: 1, borderBottomColor: "#ccc", marginVertical: 2 },

    // Tabla
    section: { marginBottom: 15 },
    title: {
        fontSize: 10, // Ajusta el tamaño del texto si es necesario
        fontWeight: "bold", // Asegúrate de que sea negrita
        textAlign: "center", // Centra el texto
        marginBottom: 8, // Margen inferior para separación
        backgroundColor: "#000", // Fondo negro
        color: "#fff", // Texto blanco
        padding: 4, // Agrega un poco de espacio interno
        textTransform: "uppercase", // Opcional: convierte el texto a mayúsculas
    },
    tableHeader: {
        backgroundColor: "#000",
        color: "#fff",
        padding: 3,
        fontSize: 8,
        fontWeight: "bold",
        textAlign: "center",
    },
    tableRow: { flexDirection: "row", borderBottomWidth: 1, borderColor: "#ccc", padding: 3 },
    tableCell: { fontSize: 7, padding: 2, textAlign: "left" }, // Justificar texto a la izquierda

    // Totales
    totalContainer: {
        marginTop: 10,
        alignItems: "flex-end", // Alinear todo a la derecha
        width: "100%", // Asegurar que el contenedor ocupe todo el ancho disponible
    },
    totalRow: {
        flexDirection: "row",
        justifyContent: "space-between", // Espaciado entre la etiqueta y el valor
        alignItems: "center", // Centrar verticalmente los elementos
        width: "30%", // Contenedor más compacto
        borderBottomWidth: 1, // Agregar una línea separadora
        borderBottomColor: "#ccc", // Color de la línea separadora
        paddingVertical: 2, // Espaciado interno para evitar que se vean amontonados
    },
    totalLabel: {
        fontSize: 8,
        fontWeight: "bold",
        textAlign: "left", // Alinear texto a la izquierda
        flex: 1, // Mantener proporción flexible
        marginRight: 2, // Espacio mínimo entre etiqueta y valor
    },
    totalValue: {
        fontSize: 8,
        textAlign: "right", // Alinear los valores numéricos a la derecha
        flex: 1, // Mantener proporción flexible
    },
});

// Función para asignar el logo correspondiente a un hotel
const asignarLogo = (idHotel) => {
    const hotel = logos.find((item) => item.id === Number(idHotel));
    return hotel ? hotel.logo : "/assets/logo2.jpg";
};

// Componente principal del PDF
const PDFGenerator = ({ formulario, monedaActiva }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            {/* Encabezado */}
            <View style={styles.header}>
                <Image src={asignarLogo(formulario.hotelSeleccionado)} style={styles.logo} />
                <Text style={styles.contractNumber}>#{formulario.consecutivo}</Text>
            </View>

            {/* Tarjetas de información */}
            <View style={styles.cardContainer}>
                {/* Información del Ejecutivo */}
                <View style={styles.card}>
                    <Text style={styles.cardTitle}>Información del Ejecutivo</Text>
                    <Text style={styles.cardText}>Ejecutiva: {formulario.nombreEjecutivo}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Cargo: {formulario.cargoEjecutivo}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Correo Electrónico: {formulario.correoEjecutivo}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Teléfono: {formulario.telefonoEjecutivo}</Text>
                </View>

                {/* Información del Cliente */}
                <View style={styles.card}>
                    <Text style={styles.cardTitle}>Información del Cliente</Text>
                    <Text style={styles.cardText}>Empresa: {formulario.empresaSeleccionada}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Cliente: {formulario.nombreCliente}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Correo Electrónico: {formulario.correoCliente}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Teléfono: {formulario.telefonoCliente}</Text>
                </View>

                {/* Información del Contrato */}
                <View style={styles.card}>
                    <Text style={styles.cardTitle}>Información de contrato</Text>
                    <Text style={styles.cardText}>Número contrato: #{formulario.consecutivo}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Fecha contrato: {formulario.fechaCreacion}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Fechas Evento: {formulario.fechaSeleccionadas || "Sin definir"}</Text>
                    <View style={styles.divider} />
                    <Text style={styles.cardText}>Nombre Evento: {formulario.nombreEvento}</Text>
                </View>
            </View>

            {/* Tabla de requerimientos */}
            {formulario.requerimientos.length > 0 && (
                <View>
                    <Text style={styles.title}>REQUERIMIENTO DE EVENTO</Text>
                    <View>
                        <View style={[styles.tableRow, { backgroundColor: "#f9f9f9" }]}>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Fecha</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Hora</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Cant.</Text>
                            <Text style={[styles.tableCell, { width: "25%" }]}>Desc. artículo</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Días</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Salones</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Precio {monedaActiva}</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Subto. {monedaActiva}</Text>
                        </View>

                        {formulario.requerimientos.map((requerimiento, index) => (
                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, { width: "10%" }]}>
                                    {requerimiento.fecha
                                        ? requerimiento.fecha
                                              .toString()
                                              .split(",")
                                              .map((part, idx) => (
                                                  <Text key={idx} style={{ display: "block" }}>
                                                      {part.trim()}
                                                  </Text>
                                              ))
                                        : "Sin definir"}
                                </Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.hora || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.cantidad}</Text>
                                <Text style={[styles.tableCell, { width: "25%" }]}>{requerimiento.descripcionArticulo}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.dias}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.salon || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.precio}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.subtotal}</Text>
                            </View>
                        ))}
                    </View>

                    <View style={styles.totalContainer}>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>SUB TOTAL {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.subtReq_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>13% IM.VENTAS {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.treceReq_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>10% IMP.SERV {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.diezReq_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>TOTAL A&B {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.totalReq_Subt_con}</Text>
                        </View>
                    </View>
                </View>
            )}
            <View style={{ height: 20 }} />
            {formulario.otroServicios.length > 0 && (
                <View>
                    <Text style={styles.title}>OTROS SERVICIOS</Text>
                    <View>
                        <View style={[styles.tableRow, { backgroundColor: "#f9f9f9" }]}>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Fecha</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Hora</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Cant.</Text>
                            <Text style={[styles.tableCell, { width: "25%" }]}>Desc. artículo</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Días</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Salones</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Precio {monedaActiva}</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Subto {monedaActiva}</Text>
                        </View>

                        {formulario.otroServicios.map((requerimiento, index) => (
                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, { width: "10%" }]}>
                                    {requerimiento.fecha
                                        ? requerimiento.fecha
                                              .toString()
                                              .split(",")
                                              .map((part, idx) => (
                                                  <Text key={idx} style={{ display: "block" }}>
                                                      {part.trim()}
                                                  </Text>
                                              ))
                                        : "Sin definir"}
                                </Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.hora || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.cantidad}</Text>
                                <Text style={[styles.tableCell, { width: "25%" }]}>{requerimiento.descripcionArticulo}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.dias}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.salon || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.precio}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.subtotal}</Text>
                            </View>
                        ))}
                    </View>
                    <View style={styles.totalContainer}>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>SUB TOTAL {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.subtOtro_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>13% IM.VENTAS {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.treceOtro_Subt_con}</Text>
                        </View>

                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>TOTAL A&B {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.totalOtro_Subt_con}</Text>
                        </View>
                    </View>
                </View>
            )}
            <View style={{ height: 20 }} />

            {formulario.requerimientoshabitaciones.length > 0 && (
                <View>
                    <Text style={styles.title}>REQUERIMIENTOS DE HABITACIONES</Text>
                    <View>
                        <View style={[styles.tableRow, { backgroundColor: "#f9f9f9" }]}>
                            <Text style={[styles.tableCell, { width: "15%" }]}>Fecha In</Text>
                            <Text style={[styles.tableCell, { width: "15%" }]}>Fecha Out</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Noches</Text>
                            <Text style={[styles.tableCell, { width: "25%" }]}>Desc. Habitación</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Cant. Habitación</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Tarifa * Noche</Text>
                            <Text style={[styles.tableCell, { width: "10%" }]}>Sub Total</Text>
                        </View>

                        {formulario.requerimientoshabitaciones.map((requerimiento, index) => (
                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, { width: "15%" }]}>{requerimiento.fechin_roomreq_con || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "15%" }]}>{requerimiento.fechout_roomreq_con || "Sin definir"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.noches_roomreq_con || "0"}</Text>
                                <Text style={[styles.tableCell, { width: "25%" }]}>{requerimiento.dec_roomreq_con || "Sin descripción"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.cant_roomreq_con || "0"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.tarifa_roomreq_con || "0.00"}</Text>
                                <Text style={[styles.tableCell, { width: "10%" }]}>{requerimiento.sub_roomreq_con || "0.00"}</Text>
                            </View>
                        ))}
                    </View>
                    <View style={styles.totalContainer}>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>SUB TOTAL {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.subtsubtRoom_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>13% IM.VENTAS {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.trecesubtRoom_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>TIP MUCAMA {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.mucamasubtRoom_Subt_con}</Text>
                        </View>
                        <View style={styles.totalRow}>
                            <Text style={styles.totalLabel}>TOTAL A&B {monedaActiva}:</Text>
                            <Text style={styles.totalValue}>{formulario.totalRequerimientos.totalsubtRoom_Subt_con}</Text>
                        </View>
                    </View>
                </View>
            )}
            <View style={{ height: 20 }} />
            {/* Salto de línea */}
            <View style={{ height: 20 }} />
            <View>
                {/* Título */}
                <Text style={styles.title}>TALES GENERAL</Text>
                {/* Contenedor del total */}
                <View style={{ flexDirection: "row", justifyContent: "flex-end", marginTop: 5 }}>
                    <View
                        style={{
                            minWidth: 120,
                            borderWidth: 1,
                            borderColor: "#ccc",
                            padding: 5,
                            backgroundColor: "#f5f5f5",
                            borderRadius: 4,
                            alignItems: "center", // Alinea el texto centrado dentro del contenedor
                        }}
                    >
                        <Text style={{ fontSize: 10, fontWeight: "bold", textAlign: "right" }}>{formulario.totalGlobalCotizacion}</Text>
                    </View>
                </View>
            </View>
            <View>
                {/* Título */}
                <View style={{ marginBottom: 10 }}>
                    <Text style={{ fontSize: 8, fontWeight: "bold", marginBottom: 4 }}>Notas: {formulario.notaCoti || ""}</Text>
                </View>
            </View>
        </Page>
        {/* Segunda página */}
        <Page size="A4" style={{ padding: 20 }}>
            <View>
                {/* Título Principal */}
                <Text
                    style={{
                        fontSize: 12,
                        fontWeight: "bold",
                        textAlign: "center",
                        marginBottom: 20,
                        textTransform: "uppercase",
                    }}
                >
                    Políticas de Contrato
                </Text>

                {/* Contrato de Habitaciones */}
                <Text style={{ fontSize: 12, fontWeight: "bold", textAlign: "center", marginBottom: 10 }}>CONTRATO DE HABITACIONES</Text>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>
                    Por favor, revise los detalles de las habitaciones solicitadas para asegurarse de que reflejan con precisión sus requisitos en
                    virtud del presente contrato.
                </Text>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>
                    El presente Acuerdo de Evento (el “Acuerdo”) es celebrado entre:
                    <Text style={{ fontWeight: "bold" }}> {formulario.celebro_contrato} </Text>, Cédula de identidad:
                    <Text style={{ fontWeight: "bold" }}> {formulario.cedula_contrato} </Text>, representando a la empresa:
                    <Text style={{ fontWeight: "bold" }}> {formulario.empresaC_contrato} </Text>, (“usted”, “El Cliente” o “su/suyo”) y la empresa que
                    actualmente opera con el nombre de
                    <Text style={{ fontWeight: "bold" }}> {formulario.hotelC_contrato} </Text>, (el “Hotel” o “nosotros” o “nuestro”).
                </Text>

                {/* Notas importantes */}
                <Text style={{ fontSize: 12, fontWeight: "bold", textAlign: "center", marginBottom: 10 }}>Notas importantes</Text>

                <View style={{ marginBottom: 15 }}>
                    <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 5 }}>
                        • A partir de 10 habitaciones, considerar $2,00 x noche, por habitación por propina de mucamas.
                    </Text>
                    <Text style={{ fontSize: 10, textAlign: "justify" }}>
                        • Para Grupos: En caso de requerir asistencia para el equipaje considerar un costo de $2,00 x persona para la noche Inn y/o
                        Out. Este servicio debe coordinarse con anticipación.
                    </Text>
                </View>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>GARANTIA DE HOSPEDAJE: {formulario.garantia_contrato} </Text>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>
                    CHECK IN | Nuestra hora de registro es a las 3:00 PM, el registro anticipado es de acuerdo a disponibilidad o bien el cliente
                    puede resguardar su equipaje hasta que su habitación esté lista. CHECK OUT | Nuestra hora de salida es a las 12:00 MD con
                    resguardo de equipaje disponible para salidas después del mediodía. La entrada anticipada y la salida tardía están sujetas a
                    disponibilidad y a la aprobación de nuestra Recepción. Habrá un cargo de $30,00 por entrada anticipada y un cargo del $40,00 por
                    salida tardía.
                </Text>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>
                    Todas las tarifas son en dólares americanos USD $. Actualmente, los impuestos nacionales y locales son los siguientes: Tarifas
                    habitación 13%.
                </Text>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>
                    REGISTRO | Al registrarse cada cliente firma su boleta de registro y entrega tarjeta de garantía para incidentales o extras.
                </Text>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>FORMA DE PAGO: {formulario.formapago_contrato}</Text>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>
                    ROOMING LIST | Se debe recibir con al menos 30 días antes del ingreso del grupo.
                </Text>

                <Text style={{ fontSize: 12, fontWeight: "bold", textAlign: "center", marginBottom: 10 }}>CONTRATO</Text>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>POLITICA DE CANCELACIONES</Text>

                <View style={{ borderWidth: 1, borderColor: "#000", marginBottom: 20 }}>
                    <View style={{ flexDirection: "row" }}>
                        <Text style={{ fontSize: 10, flex: 1, textAlign: "center" }}>Cantidad de días Antes del Ingreso del grupo</Text>
                        <Text style={{ fontSize: 10, flex: 1, textAlign: "center" }}>Penalidad</Text>
                    </View>
                    <View style={{ flexDirection: "row", borderTopWidth: 1, borderColor: "#000" }}>
                        <Text style={{ fontSize: 10, flex: 1, textAlign: "center" }}> {formulario.dato1_contrato} </Text>
                        <Text style={{ fontSize: 10, flex: 1, textAlign: "center" }}> {formulario.dato2_contrato} </Text>
                    </View>
                </View>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>
                    Sobre reducciones de habitaciones, una vez firmado el contrato no se permiten reducciones.
                </Text>

                <Text style={{ fontSize: 10, textAlign: "justify", marginBottom: 15 }}>
                    Una vez que recibamos el presente Contrato de habitaciones firmado, este Contrato de Eventos se convertirá en un compromiso
                    vinculante para ambas partes; si este Contrato es devuelto firmado con algún cambio escrito a mano, no constituirá una aceptación,
                    sino una contraoferta por su parte que podrá ser rechazada o aceptada por escrito a absoluta discreción del hotel.
                </Text>

                <Text style={{ fontSize: 12, fontWeight: "bold", textAlign: "center", marginBottom: 20 }}>ACEPTACIÓN Y CONSENTIMIENTO</Text>

                <View style={{ flexDirection: "row", justifyContent: "space-between", marginBottom: 20 }}>
                    <View style={{ alignItems: "center" }}>
                        <Text style={{ fontSize: 10, textAlign: "center", marginBottom: 5 }}>_______________________________</Text>
                        <Text style={{ fontSize: 10, textAlign: "center" }}>FIRMA CLIENTE</Text>
                    </View>
                    <View style={{ alignItems: "center" }}>
                        <Text style={{ fontSize: 10, textAlign: "center", marginBottom: 5 }}>_______________________________</Text>
                        <Text style={{ fontSize: 10, textAlign: "center" }}>NOMBRE CLIENTE</Text>
                    </View>
                    <View style={{ alignItems: "center" }}>
                        <Text style={{ fontSize: 10, textAlign: "center", marginBottom: 5 }}>_______________________________</Text>
                        <Text style={{ fontSize: 10, textAlign: "center" }}>FECHA</Text>
                    </View>
                </View>

                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                    <View style={{ alignItems: "center" }}>
                        <Text style={{ fontSize: 10, textAlign: "center", marginBottom: 5 }}>{formulario.admin_name}</Text>
                        <Text style={{ fontSize: 10, textAlign: "center", marginBottom: 5 }}>_______________________________</Text>
                        <Text style={{ fontSize: 10, textAlign: "center" }}>FIRMA HOTEL</Text>
                    </View>
                    <View style={{ alignItems: "center" }}>
                        <Text style={{ fontSize: 10, textAlign: "center", marginBottom: 5 }}>{formulario.admin_hotel}</Text>
                        <Text style={{ fontSize: 10, textAlign: "center", marginBottom: 5 }}>_______________________________</Text>
                        <Text style={{ fontSize: 10, textAlign: "center" }}>NOMBRE HOTEL</Text>
                    </View>
                    <View style={{ alignItems: "center" }}>
                        <Text style={{ fontSize: 10, textAlign: "center", marginBottom: 5 }}>{formulario.admin_fecha}</Text>
                        <Text style={{ fontSize: 10, textAlign: "center", marginBottom: 5 }}>_______________________________</Text>
                        <Text style={{ fontSize: 10, textAlign: "center" }}>FECHA</Text>
                    </View>
                </View>
            </View>
        </Page>
    </Document>
);

// Componente para descargar el PDF
const PDFGeneratorCorto = ({ formulario, nombre, mostrarPoliticasCortas }) => {
    // Obtener la moneda activa o asignar un valor predeterminado.
    const monedaActiva = formulario.MonedaTipo.find((moneda) => moneda.estado)?.nombre || "$";

    return (
        <PDFDownloadLink
            document={<PDFGenerator formulario={formulario} monedaActiva={monedaActiva} />}
            fileName={`${nombre}_${formulario.consecutivo}.pdf`} // Corregida la interpolación
        >
            {({ loading }) => (
                <button type="button" className="btn btn-success me-2">
                    {loading ? (
                        <>
                            <i className="ti ti-spinner ti-spin"></i> Generando PDF...
                        </>
                    ) : (
                        <>
                            <i className="ti ti-download"></i> Descargar {nombre}
                        </>
                    )}
                </button>
            )}
        </PDFDownloadLink>
    );
};

export default PDFGeneratorCorto;
